<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container class="container--md mt--6">
      <div>
        <card class="no-border-card mt-2 card-results" header-classes="pb-1" body-classes="px-0 pt-0 pb-0" footer-classes="pb-2">
          <template slot="header">
            <b-row align-h="end">

            </b-row>
          </template>
          <div style="position: relative">

            <h2>Data Export</h2>

            <p>
              Put Date Selector Here And Button For Export
            </p>
            <p>
              <button @click="onClick()">Download</button>
            </p>

          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { BasePagination } from '@/components';
// import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';
import swal from 'sweetalert2';
import LoadingPanel from '@/components/LoadingPanel.vue';
import axios from 'axios'
import { authHeader } from '../../_helpers';

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_API_HOSTNAME}/api/brands/`,
  withCredentials: false,
  headers: authHeader()
})

export default {
  // mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      propsToSearch: ['name', 'description', 'brand'],
      data: null,
      itemLimit: '10',
      view: 'table',
      sq: this.$route.query.sq,
      loading: '',
      pauseSearch: false,
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
      currentDate: ''
    };
  },
   computed: {
     history() {
      return Object.values(this.$store.state.reportings.history)
     },
     isLoading() {
       return this.$store.getters.ingredientsLoading
     },
     to() {
      let highBound = this.from + this.perPage;
      if (this.count < highBound) {
        highBound = this.count;
      }
      return highBound;
    },
    from() {
      return this.perPage * (this.currentPage - 1);
    },
    count() {
      return this.$store.state.ingredients.all[0];
    }
  },
  methods: {
    dateFormat(date) {
      var local = new Date(date);
      return local.toLocaleDateString("en-US");
    },
    paginationChanged(page) {
      this.currentPage = page;
      this.searchIngredients();
    },
    onClick() {
      axios({
            url: `${process.env.VUE_APP_API_HOSTNAME}/api/loggers/pivottable`,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
             var fileURL = window.URL.createObjectURL(new Blob([response.data]));
             var fileLink = document.createElement('a');

             fileLink.href = fileURL;
             fileLink.setAttribute('download', 'recipe-data-pivot-table.xlsx');
             document.body.appendChild(fileLink);

             fileLink.click();
        });
    },
    searchHistory() {
      const { dispatch } = this.$store;
      dispatch("reportings/getUserHistory", this.$store.state.authentication.user.user.id);
    },
    toggleActive(event, view) {
      event.preventDefault();

      const button = event.target.closest('.btn-view');
      const card = document.querySelector('.card-results');

      button.classList.add('active')

      Array.prototype.filter.call(button.parentNode.children, function(child){
        if (child !== button) {
          child.classList.remove('active')
        }
      });

      this.view = view;

      this.view == 'grid'
        ? card.classList.add('card-results--alt')
        : card.classList.remove('card-results--alt')
    }
  },
  created() {
    this.searchHistory();
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    perPage (val,old) {
      this.currentPage = 1;
      this.searchIngredients();
    },
    sq: function (val,old) {
      this.sq = val;
        if (!this.pauseSearch) {
          setTimeout(() => {
            this.searchIngredients();
            this.pauseSearch = false;
          }, 800); // 1 sec delay
        }
        this.pauseSearch = true;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
